import { Navigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { AuthLoadingFallback } from '@/components/auth/ProtectedRoute';

/**
 * @param {{ code: string; children: import('react').ReactNode }} props
 */
export function PackageGate({ code, children }) {
  const { user, authHydrated } = useApp();
  if (!authHydrated) return <AuthLoadingFallback />;
  const upper = String(code || '')
    .trim()
    .toUpperCase();
  const active = (user.active_packages || []).map((c) => String(c).toUpperCase());
  if (!active.includes(upper)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
